import React from 'react';
import Bubble from './bubble';
import { ConfirmButton, ConfirmText} from './confirmButton';
import { OkButton, OkText} from './okButton';
import { fontFamily } from '../../library/constants';
import { getExpandedHeightForBubble/*, getDummyText*/ } from '../../library/calc';
import { Triangletip, Trianglehide } from './triangletip';

import Content from './content';

export default ({
    n,
    contentShownInToolTip,
    left,
    top,
    stopStageClickPropagation,
    p,
    pr_id,
    updated,
    nn,
    nm,
    nodeShownInMatchBubble,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
    placementShownInToolTip,
    shiftLeftOnToolTip,
    shiftTopOnToolTip,
    bubbleWidth,
    runTranslatePhraseInToolTip,
    translateVarStrInToolTip,
    okLabelInToolTip,
    confirmLabelWidthInToolTip,
    okLabelWidthInToolTip,
    confirmLabelInToolTip,
    okCallbackInToolTip,
    confirmCallbackInToolTip,
  }) => {


  const buttonsWidthAddedToDefaultButtonSize = 10;
  const inBetweenButtonSpacing = 10;

  let widthOfBubble = ( typeof(bubbleWidth) !== 'undefined'? bubbleWidth: 62);

  if(typeof(confirmLabelInToolTip) !== 'undefined'){
    widthOfBubble += confirmLabelWidthInToolTip + okLabelWidthInToolTip - inBetweenButtonSpacing - buttonsWidthAddedToDefaultButtonSize;
  }
  const fontSizeMatchLabel = 3.5;
  const fontFamilyMatchLabel = fontFamily;

  let expandHeightBy = undefined;
  let confirmHeight = ( typeof(confirmLabelInToolTip) !== 'undefined' ||
                        typeof(okLabelInToolTip) !== 'undefined'
                        ? 6: 0);

  if(runTranslatePhraseInToolTip ){
    expandHeightBy = getExpandedHeightForBubble({content: contentShownInToolTip + translateVarStrInToolTip, fontSizeMatchLabel, fontFamilyMatchLabel, width: widthOfBubble});
  } else {
    expandHeightBy = getExpandedHeightForBubble({content: contentShownInToolTip, fontSizeMatchLabel, fontFamilyMatchLabel, width: widthOfBubble});
  }

  if(typeof(confirmLabelInToolTip) !== 'undefined' ||
     typeof(okLabelInToolTip) !== 'undefined'){
    expandHeightBy += 2;
  }

  const defaultBubbleBodyHeight = 7;

  let topBubble = ( placementShownInToolTip === 'over' ? -16: 36);

  if(typeof(shiftTopOnToolTip) !== 'undefined'){
    topBubble += shiftTopOnToolTip;
  }

  let leftBubble = shiftLeftOnToolTip;

  const props = {
    n,
    contentShownInToolTip,
    left,
    top,
    stopStageClickPropagation,
    cursorBecomesMove,
    cursorBecomesPointer,
    p,
    pr_id,
    updated,
    nn,
    nm,
    leftBubble,
    runTranslatePhraseInToolTip,
    translateVarStrInToolTip,
    okLabelInToolTip,
    confirmLabelInToolTip,
    okCallbackInToolTip,
    confirmCallbackInToolTip,
  };

  const adapt = ( placementShownInToolTip === 'over' ? expandHeightBy + confirmHeight: 0);

  const bubbleProps = {
      ...props,
      yCoord4Bubble: topBubble - adapt,
      bubbleBodyHeight: defaultBubbleBodyHeight + expandHeightBy + confirmHeight,
      bubbleBodyWidth: widthOfBubble + 4,
      strokeWidth: .3,
      placementShownInToolTip,
      fill: '#F8F7F7',
  };

  const paddingTopBubble = 3;
  const contentProps = {
      ...props,
      yCoord4Matchbox: bubbleProps.yCoord4Bubble + paddingTopBubble,
      width4Matchbox: 19,
      leftStart4Boxes: leftBubble + 2.5,
      paddingBetweenBoxes: 2,
      topLabel: topBubble + paddingTopBubble - adapt,
      leftStart4MatchLabel: 7.3,
      fontSizeMatchCount: 4,
      fontSizeMatchLabel,
      fontFamilyMatchLabel,
      matchBoxHeight: 10,
      textWidth: 12,
      widthOfBubble,
  };

  const buttonProps = {
    userTouchedNode,
    inBetweenButtonSpacing,
    okLabelWidthInToolTip,
    confirmLabelWidthInToolTip,
    buttonsWidthAddedToDefaultButtonSize,
    buttonsLeft:14,
    buttonsTop: 12.5,
    buttonsLeftPadding: 5,
    buttonsTopPadding: 1.5,
  };

  const tooltipArray = [
    <Bubble  key={Math.random()} {...bubbleProps}/>,
    <Triangletip  key={Math.random()} {...bubbleProps}/>,
    <Trianglehide  key={Math.random()} {...bubbleProps}/>,
    <Content key={Math.random()} {...contentProps} />,
  ];

  if( typeof(okLabelInToolTip) !== 'undefined') {
      tooltipArray.push(<OkButton  key={Math.random()} {...bubbleProps} {...buttonProps}/>)
      tooltipArray.push(<OkText  key={Math.random()} {...bubbleProps} {...buttonProps}/>)
  };

  if( typeof(confirmLabelInToolTip) !== 'undefined') {
      tooltipArray.push(<ConfirmButton  key={Math.random()} {...bubbleProps} {...buttonProps}/>)
      tooltipArray.push(<ConfirmText  key={Math.random()} {...bubbleProps} {...buttonProps}/>)
  };

  return tooltipArray;
};

